import { render, staticRenderFns } from "./TicketAssigneeSelect.html?vue&type=template&id=0a7f0f7c&scoped=true&external"
import script from "./TicketAssigneeSelect.vue?vue&type=script&lang=js"
export * from "./TicketAssigneeSelect.vue?vue&type=script&lang=js"
import style0 from "./TicketAssigneeSelect.scss?vue&type=style&index=0&id=0a7f0f7c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7f0f7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAutocomplete,VChip})
